export const environment = {
    production: false,
    HTTP_PROTOCOL: 'https',
    SITE_DOMAIN: 'stage.boodmo.dev',
    API_HOSTNAME: '/api',
};
